import { createLogger } from "./logger.js";
//#region ../src/utils/failure-tracker.ts
/**
* Generic Failure Tracker Factory
*
* Shared pattern extracted from capture-failure-tracker and write-failure-tracker.
* Tracks consecutive failures, warns the user once when a threshold is exceeded,
* and supports session-level reset.
*/
/**
* Create a generic failure tracker.
*
* @param config - Tracker configuration
* @returns A FailureTracker instance
*/
function createFailureTracker(config) {
	const { label, warningMessage, defaultThreshold, onWarning, logLevel = "warn" } = config;
	const threshold = config.failureThreshold ?? defaultThreshold;
	const log = createLogger(label);
	let consecutiveFailures = 0;
	let warningShown = false;
	return {
		recordSuccess() {
			consecutiveFailures = 0;
		},
		recordFailure(error) {
			consecutiveFailures++;
			if (logLevel === "error") log.error(`${label} failure #${consecutiveFailures}:`, error);
			else log.warn(`${label} failure #${consecutiveFailures}`);
			if (consecutiveFailures >= threshold && !warningShown) {
				warningShown = true;
				onWarning(warningMessage);
			}
		},
		getFailureCount() {
			return consecutiveFailures;
		},
		hasWarned() {
			return warningShown;
		},
		reset() {
			consecutiveFailures = 0;
			warningShown = false;
		}
	};
}
//#endregion
export { createFailureTracker };
